import script from "./RichTextEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./RichTextEditor.vue?vue&type=script&setup=true&lang=ts"

import "./RichTextEditor.vue?vue&type=style&index=0&id=6801fd84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6801fd84"]])

export default __exports__